Ext.define('SA.CrosstabMetadataCell', {
    html: [
        '<table class="sa-crosstab-metadata-cell-table">',
            '<tr>',
                '<td class="sa-crosstab-metadata-cell-label">Sample</td>',
                '<td class="sa-crosstab-metadata-cell-value sa-crosstab-metadata-cell-value-sample"></td>',
            '</tr>',
            '<tr>',
                '<td class="sa-crosstab-metadata-cell-label">Weighted (000)</td>',
                '<td class="sa-crosstab-metadata-cell-value sa-crosstab-metadata-cell-value-weight"></td>',
            '</tr>',
            '<tr>',
                '<td class="sa-crosstab-metadata-cell-label">Total %</td>',
                '<td class="sa-crosstab-metadata-cell-value sa-crosstab-metadata-cell-value-total-percent"></td>',
            '</tr>',
        '</table>'
    ],

    constructor({parent}) {
        this.el = parent.appendChild(document.createElement('div'));
        this.el.className = 'sa-crosstab-metadata-cell';
        this.el.innerHTML = this.html.join('');
    },

    getTplData(state) {
        if (state.empty) {
            return {sample: 'N/A', weight: 'N/A', percentTotal: 'N/A'};
        }

        return {
            sample: SA.formatValue(state.data.count, '%d'),
            weight: SA.formatValue((state.data.weight / 1000), '%d'),
            percentTotal: SA.CrosstabBodyCell.formatPercent(state.data['% of all'])
        };
    },

    setState(state) {
        var tplData = this.getTplData(state),
            get = suffix => this.el.querySelector(`.sa-crosstab-metadata-cell-value-${suffix}`);

        this.el.classList.toggle('sa-crosstab-metadata-cell-null', state.empty);
        this.el.classList.toggle('sa-crosstab-metadata-cell-dragging', state.dragging);

        get('sample').textContent = tplData.sample;
        get('weight').textContent = tplData.weight;
        get('total-percent').textContent = tplData.percentTotal;
    },

    setVisible(visible) {
        this.el.classList.toggle('sa-crosstab-metadata-cell-hidden', !visible);
    }
});